import type { CategoryContent } from '../row.js';

export const GERMAN_HISTORY: CategoryContent = {
  bscba: [
    [
      'Welke Pruisische vorst is het meest beroemd om militaire hervormingen en territoriale expansie in de 18de eeuw?',
      [
        'Frederik de Grote',
        'Frederik Willem I',
        'Karel XII van Zweden',
        'Jozef II van Oostenrijk',
      ],
      0,
      'Frederik de Grote (r. 1740–1786) transformeerde Pruisen door militaire innovatie en verovering tot een grootmacht.',
    ],
    [
      'Welke benadering gebruikte Otto von Bismarck om Duitse eenmaking te bereiken?',
      [
        'Pragmatische machtspolitiek boven ideologie',
        'Democratische hervormingen en constitutionele compromissen',
        'Alliantie met socialistische bewegingen',
        'Religieus gezag en pauselijke steun',
      ],
      0,
      'Bismarcks Realpolitik gebruikte militaire kracht en diplomatie—niet ideologie—voor Duitse eenmaking.',
    ],
    [
      'Welk conflict in 1870–1871 leidde direct tot Duitse eenmaking?',
      [
        'De Frans-Pruisische Oorlog',
        'De Oostenrijks-Pruisische Oorlog',
        'De Krimoorlog',
        'De Napoleontische Oorlogen',
      ],
      0,
      'Duitse overwinning in de Frans-Pruisische Oorlog maakte de uitroeping van het Duitse Keizerrijk op 18 januari 1871 mogelijk.',
    ],
    [
      'Wie werd in 1871 de eerste Duitse Keizer?',
      [
        'Willem I',
        'Willem II',
        'Otto von Bismarck',
        'Frederik Willem IV',
      ],
      0,
      'Willem I, Koning van Pruisen, werd uitgeroepen tot Duitse Keizer. Bismarck werd Kanselier onder zijn gezag.',
    ],
    [
      'Welk belangrijk verdrag legde Frankrijk zware straffen op na Duitse eenmaking?',
      [
        'Het Verdrag van Frankfurt (1871)',
        'Het Verdrag van Versailles (1919)',
        'Het Verdrag van Wenen (1815)',
        'De Vrede van Westfalen (1648)',
      ],
      0,
      'Het Verdrag van Frankfurt (1871) verplichtte Frankrijk tot een betaling van 5 miljard frank en tot afstand van Elzas-Lotharingen.',
    ],
    [
      'Wat was de primaire oorzaak van instabiliteit in de vroege Weimarrepubliek?',
      [
        'Bitterheid over Versailles',
        'Succesvolle industrialisatie in het buitenland',
        'Eensgezinde politieke consensus',
        'Universele steun van buurlanden',
      ],
      0,
      'Het Verdrag van Versailles legde herstelbetalingen, grondverlies en militaire limieten op die Weimar destabiliseerden.',
    ],
    [
      'In welk jaar verwoestte hyperinflatie de Duitse economie?',
      [
        '1923',
        '1929',
        '1933',
        '1919',
      ],
      0,
      'Duitse hyperinflatie bereikte een hoogtepunt in 1923 en vernietigde spaargeld en politieke stabiliteit in Weimar.',
    ],
    [
      'Wat was de structuur van de Weimarregering?',
      [
        'Een federale parlementaire republiek',
        'Een absolute monarchie',
        'Een unitaire dictatuur',
        'Een confederatie zonder centrale macht',
      ],
      0,
      'Weimar was een federale parlementaire democratie met een verkozen president, kanselier en bicameraal parlement.',
    ],
    [
      'Welke mondiale gebeurtenis destabiliseerde Weimar in 1929?',
      [
        'De beurscrash van 1929',
        'Japanse invasie van Mantsjoerije',
        'Italiaanse fascistische expansie',
        'Sovjetische collectivisering van landbouw',
      ],
      0,
      'De Wall Street-crash van 1929 veroorzaakte de Grote Depressie, die verwoestend was voor Weimars fragiele economie.',
    ],
    [
      'Wat markeerde het begin van de Nazi-regel in Duitsland?',
      [
        'Hitlers benoeming tot Kanselier',
        'Het Verdrag van Versailles in 1919',
        'De hyperinflatie van 1923',
        'De Putsch van München van 1923',
      ],
      0,
      'Hitler werd op 30 januari 1933 Kanselier benoemd. De Machtigingswet van maart gaf hem dictatoriale macht.',
    ],
    [
      'Wat vestigden de Nürnbergwetten van 1935?',
      [
        'Ontneming van het Joodse staatsburgerschap',
        'Militaire allianties met Italië en Japan',
        'Territoriale expansie naar Oostenrijk',
        'Een democratisch constitutioneel raamwerk',
      ],
      0,
      'De Nürnbergwetten ontnamen Joden het Duitse burgerschap en verboden gemengde huwelijken. Dit was het begin van hun wettelijke vervolging.',
    ],
    [
      'Welke kernideologie definieerde het Nazi-regime?',
      [
        'Rassistisch fascisme',
        'Liberale democratie',
        'Marxistisch communisme',
        'Constitutionele monarchie',
      ],
      0,
      'Nazisme fuseerde fascisme, extreem antisemitisme en pseudowetenschappelijke ideologie gebaseerd op Arische suprematie.',
    ],
    [
      'Wat was het directe gevolg van Duitslands nederlaag in Wereldoorlog II in 1945?',
      [
        'Verdeling in bezettingszones',
        'Herstel van de Pruisische monarchie',
        'Duitse expansie naar het oosten',
        'Eenmaking onder een Duitse supermacht',
      ],
      0,
      'Na 1945 verdeelden geallieerde troepen Duitsland in Amerikaanse, Britse, Sovjetische en Franse bezettingszones.',
    ],
    [
      'Welke structuur symboliseerde de Koude Oorlog-verdeling tussen Oost- en West-Duitsland?',
      [
        'De Berlijnse Muur',
        'Het Verdrag van Versailles',
        'De Reformatie',
        'Het Congres van Wenen',
      ],
      0,
      'De Berlijnse Muur, gebouwd in 1961, verdeelde Berlijn en vertegenwoordigde de Koude Oorlog-verdeling 28 jaar lang tot 1989.',
    ],
    [
      'Wat veroorzaakte de val van de Berlijnse Muur in 1989?',
      [
        'Ineenstorting van Sovjetische macht',
        'Een militaire invasie vanuit het westen',
        'Een interne West-Duitse revolutie',
        'Economisch succes van Oost-Duitsland',
      ],
      0,
      'Groeiend verzet in Oost-Duitsland en de weigering van de Sovjet-Unie om geweld te gebruiken leidden tot de val van de Muur in november 1989.',
    ],
  ],
  msc: [
    [
      'Welke naam beschrijft de losse associatie van 39 Duitse staten van 1815 tot 1866?',
      [
        'De Duitse Confederatie',
        'De Zollverein',
        'Het Heilige Roomse Rijk',
        'De Pruisische Liga',
      ],
      0,
      'De Duitse Confederatie (1815–1866) was een losse associatie van soevereine Duitse staten onder Oostenrijks voorzitterschap.',
    ],
    [
      'Welke Pruisisch-geleide douaneunie sloot Oostenrijk uit en verenigde Duitse tarieven?',
      [
        'De Zollverein',
        'De Hanze',
        'De Rijnbond',
        'De Duitse Handelsbond',
      ],
      0,
      'De Zollverein (1834) verenigde Duitse tarieven terwijl Oostenrijk werd uitgesloten, wat de Pruisische dominantie bevorderde.',
    ],
    [
      'Wat probeerde het Frankfurtse Parlement van 1848–1849 te bereiken?',
      [
        'Een verenigde Duitse natiestaat creëren',
        'Oostenrijkse dominantie over Duitsland afdwingen',
        'Handelsakkoorden met Frankrijk onderhandelen',
        'Theologische geschillen uit de Reformatie aanpakken',
      ],
      0,
      'Het Frankfurtse Parlement was een liberale poging Duitsland constitutioneel te verenigen, maar slaagde niet.',
    ],
    [
      'Welk principe dreef Bismarcks uitspraak over Duitse eenmaking door "bloed en ijzer"?',
      [
        'Militaire kracht, niet onderhandeling',
        'Een zuiver defensieve militaire doctrine',
        'Economische sancties als primair middel',
        'Diplomatieke overreding en onderhandeling',
      ],
      0,
      '"Bloed en ijzer" (Blut und Eisen) drukte Bismarcks geloof uit dat militaire overwinning eenmaking vereiste.',
    ],
    [
      'Welk conflict van 1866 verwijderde Oostenrijk definitief uit Duitse aangelegenheden?',
      [
        'Pruisisch-Oostenrijkse Oorlog',
        'De Napoleontische Oorlogen',
        'De Dertigjarige Oorlog',
        'De Spaanse Successieoorlog',
      ],
      0,
      'De Oostenrijks-Pruisische Oorlog van 1866 versloeg Oostenrijk en vestigde Pruisische hegemonie in Duitse politiek.',
    ],
    [
      'Wat legde herstelbetalingen en grondverlies op Frankrijk na de Frans-Pruisische Oorlog?',
      [
        'Verdrag van Frankfurt (1871)',
        'Het Verdrag van Parijs (1815)',
        'Het Verdrag van Westfalen (1648)',
        'Het Verdrag van Wenen (1815)',
      ],
      0,
      'Het Verdrag van Frankfurt (1871) legde 5 miljard goudfrancen herstelbetalingen op en cedeerde Elzas-Lotharingen.',
    ],
    [
      'Welke term beschrijft Bismarcks conservatieve coalitie van landadel en industriëlen?',
      [
        'Sammlungspolitik',
        'Kulturkampf (culturele strijd)',
        'Weltpolitik (wereldpolitiek)',
        'Lebensraum (leefruimte)',
      ],
      0,
      'Sammlungspolitik verenigde landeigenaars en industriëlen om de elitemacht te beschermen tegen socialistische bewegingen.',
    ],
    [
      'Wat was de poging van de Spartacisten tot machtsgrijping in vroeg Weimar?',
      [
        'Een gewapende opstand, neergeslagen door Freikorps',
        'Een succesvolle sociaaldemocratische hervormingsbeweging',
        'Een alliantie met Nazi\'s',
        'Een vreedzame boerenbeweging',
      ],
      0,
      'De Spartacistische Opstand van 1919, geleid door Rosa Luxemburg en Karl Liebknecht, werd brutaal onderdrukt.',
    ],
    [
      'Wat bereikt het Dawes-plan van 1924?',
      [
        'Amerikaanse leningen en herstructurering',
        'Eisde volledige Duitse ontwapening',
        'Stelde Sovjet-Duitse samenwerking voor',
        'Autoriseerde Franse bezetting van het Ruhrgebied',
      ],
      0,
      'Het Dawes-plan (1924) reorganiseerde herstelbetalingen en verschafte Amerikaanse leningen ter stabilisering.',
    ],
    [
      'Wat karakteriseerde de "Gouden Twintig" periode (ca. 1924–1929) in Weimar?',
      [
        'Culturele en economische opleving',
        'Volledige economische ineenstorting',
        'Afwijzing van buitenlandse investeringen',
        'Communistisch industrialisatiesucces',
      ],
      0,
      'De "Gouden Twintig" zagen culturele bloei en economisch herstel voordat de Grote Depressie toesloeg.',
    ],
    [
      'Welk juridisch mechanisme gaf Hitler noodwetgevingsbevoegdheden in 1933?',
      [
        'De Machtigingswet',
        'Een militaire coup',
        'Een volksstemming',
        'Een presidentieel decreet alleen',
      ],
      0,
      'De Machtigingswet stelde Hitler in staat wetten aan te nemen zonder goedkeuring van de Reichstag, waarmee een dictatuur werd gevestigd.',
    ],
    [
      'Welke pseudowetenschappelijke grondslag rechtvaardigde de Nazi-rassenwetten en de vervolging?',
      [
        'Valse rassentheorieën over Arische suprematie',
        'Een doctrine afgeleid van christelijke theologie',
        'Economische concurrentie met Joodse bedrijven',
        'Legitieme biologie aanvaard wereldwijd',
      ],
      0,
      'Nazi-ideologie misbruikte pseudowetenschappelijke rassentheorie om genocide en vervolging te rechtvaardigen.',
    ],
    [
      'Welke term omvat de Nazi-genocide tegen Joden en andere doelgroepen?',
      [
        'De Holocaust',
        'Kristallnacht',
        'De Eindlösung',
        'De Blitzkrieg',
      ],
      0,
      'De Holocaust was de systematische genocide van zes miljoen Joden en miljoenen anderen door het Nazi-regime.',
    ],
    [
      'Hoe beïnvloedde het Marshallplan het herstel van West-Duitsland?',
      [
        'Amerikaanse hulp financierde herstel',
        'Militaire bezetting voor onbepaalde tijd',
        'Herstelbetalingen naar de Sovjet-Unie',
        'Gedwongen Sovjet-stijl collectivisering van landbouw',
      ],
      0,
      'Het Marshallplan verschafte cruciale Amerikaanse hulp voor West-Duits economisch herstel en democratische consolidatie.',
    ],
    [
      'Welke ideologische verdeling karakteriseerde Duitsland tijdens de Koude Oorlog?',
      [
        'West-Duitsland kapitalistisch, Oost-Duitsland communistisch',
        'Beide waren monarchieën die herstel zochten',
        'Beide handhaafden gelijke interne democratie',
        'Oost-Duitsland was kapitalistisch, West-Duitsland socialistisch',
      ],
      0,
      'Oost-Duitsland (DDR) was communistisch onder Sovjet-controle; West-Duitsland (BRD) was kapitalistische parlementaire democratie.',
    ],
  ],
  phd: [
    [
      'Hoe transformeerden de Landwehr-hervormingen (1807–1815) de Pruisische militaire organisatie?',
      [
        'Door het leger te combineren met militiereserves',
        'Door uitsluitend op huursoldaten te vertrouwen',
        'Door zeeën boven land te prioriseren',
        'Door staande legers af te schaffen voor feodale heffingen',
      ],
      0,
      'Scharnhorsts Landwehr-hervormingen creëerden universele dienstplicht en combineerden professionele troepen met reservetroepen.',
    ],
    [
      'Hoe isoleerde de Zollverein-tariefstructuur Oostenrijk terwijl Duitse staten economisch werden geïntegreerd?',
      [
        'Hoge externe tarieven, vrije binnenhandel',
        'Universeel gelijke tarieven zonder discriminatie',
        'Subsidies die uitsluitend landbouwbelangen bevorderden',
        'Volledige afschaffing van alle tarieven tussen de staten',
      ],
      0,
      'Zollverein-tarieven integreerden Duitse staten economisch terwijl ze Oostenrijkse belangen structureel uitsloten.',
    ],
    [
      'Welk historiografisch debat ging over de vraag of Duitse eenmaking voortsproot uit eliteactie of populair nationalisme?',
      [
        '"Van boven" versus "van beneden"',
        'Of Pruisen of Oostenrijk de eenmaking geleid zou hebben',
        'Of industrialisatie of landbouwontwikkeling de drijvende kracht was',
        'Of Duitse cultuur de natiestaat voorafging',
      ],
      0,
      'Historici debatteren of Bismarcks machtsuitoefening vanuit de elite of nationalisme van onderop de eenmaking dreef.',
    ],
    [
      'Welke onderliggende spanningen tussen staat en samenleving legde de Kulturkampf (1871–1878) in het nieuwe Keizerrijk bloot?',
      [
        'Conflict tussen nationalisme en katholieke trouw',
        'Puur theologische doctrinegeschillen',
        'Een katholieke campagne voor politieke dominantie',
        'Een anti-Joodse alliantie tussen protestanten en katholieken',
      ],
      0,
      'Kulturkampf stelde Bismarcks gecentraliseerde natiestaat tegen katholieke institutionele onafhankelijkheid.',
    ],
    [
      'Hoe vertegenwoordigde Sammlungspolitik een strategische verschuiving in het behoud van elitedominantie?',
      [
        'Door agrarische en industriële elites te verenigen',
        'Door democratische kiesrechthervormingen in te voeren',
        'Door conservatieve facties een alliantie te laten sluiten met socialisten',
        'Door militaristische partijorganisatie na te streven',
      ],
      0,
      'Sammlungspolitik consolideerde conservatieve elites om zich tegen sociaaldemocratische politiek te verzetten.',
    ],
    [
      'Hoe overtrof de Duitse industriële ontwikkeling onder het Tweede Keizerrijk Groot-Brittannië tegen 1914?',
      [
        'Duitsland overtrof Groot-Brittannië in zware industrie',
        'Groot-Brittannië bleef in alle sectoren permanent dominant',
        'Duitsland concentreerde zich uitsluitend op landbouw',
        'Industriële ontwikkeling was verwaarloosbaar in beide naties',
      ],
      0,
      'De Duitse zware industrie overtrof die van Groot-Brittannië; Duitse bedrijven vormden syndicaten, anders dan hun Britse concurrenten.',
    ],
    [
      'Wat verklaart het historiografische concept "vetoïzering" over Weimar-ineenstorting?',
      [
        'Elite-deadlock blokkeerde democratische oplossingen',
        'Het proces van succesvolle democratisering',
        'Hoe meervoudige veto-machten individuele vrijheden beschermden',
        'Toenemende machtconcentratie in socialistische partijen',
      ],
      0,
      'Vetoïzeringstheorie beschrijft hoe verdeelde elites legislatieve actie blokkeerden, wat de Nazi-opkomst mogelijk maakte.',
    ],
    [
      'Hoe functioneerde de "dolkstootlegende" (Dolchstoßlegende) ideologisch in Weimar-politiek?',
      [
        'Een vals verhaal dat beweerde dat burgers het leger hadden verraden',
        'Een nauwkeurige historische beoordeling van militaire omstandigheden in 1918',
        'Een socialistische propagandacreatie',
        'Een Oostenrijkse politieke aanklacht tegen Duitsland',
      ],
      0,
      'De Dolchstoßlegende beweerde ten onrechte dat het thuisfront had verraden in plaats van dat er sprake was van militaire nederlaag, en mobiliseerde daarmee de Nazi-ideologie.',
    ],
    [
      'Welke constitutionele zwaktes in Weimar stelden Hitlers machtconsolidatie mogelijk?',
      [
        'Artikel 48 en een gefragmenteerde Reichstag',
        'Een systeem te restrictief voor enige uitvoerende actie',
        'Buitensporige constitutionele bescherming van burgerrechten',
        'Een verbod op politieke partijvorming',
      ],
      0,
      'Artikel 48 stelde presidentiële nooddecreten toe; het proportionele kiesstelsel fragmenteerde stabiele coalities.',
    ],
    [
      'Wat bereikt Nazi-"Gleichschaltung" in het herstructureren van de civiele samenleving?',
      [
        'Totale Nazi-controle van alle organisaties',
        'Decentralisering van macht naar lokale gemeenschappen',
        'Versterking van de wetgevende macht van de Reichstag',
        'Afschaffing van politieke partijen ter gunste van monarchie',
      ],
      0,
      'Gleichschaltung synchroniseerde alle instellingen onder Nazi-controle en elimineerde de onafhankelijkheid van het maatschappelijk middenveld.',
    ],
    [
      'Hoe verschilde SS-ideologie van Wehrmacht-professionele militaire doctrine?',
      [
        'De SS omarmde rasideologie en misdaden',
        'Ze waren identiek in doel en acties',
        'De Wehrmacht verwierp alle Nazi-ideologie',
        'De SS was exclusief een arbeidsorganisatie',
      ],
      0,
      'De SS voerde raciale genocidemisdaden namens de Nazi\'s uit; de betrokkenheid van de Wehrmacht bij deze gruweldaden blijft historisch betwist.',
    ],
    [
      'Hoe rechtvaardigde het "Lebensraum"-concept Nazi-expansie naar het oosten?',
      [
        'Gebied voor Duitse kolonisatie',
        'Een vreedzaam cultureel-uitwisselingsprogramma',
        'Een handelsovereenkomst met Oosteuropese naties',
        'Een defensief akkoord met Polen',
      ],
      0,
      'Lebensraum rechtvaardigde oostwaartse verovering en genocide als nodig voor Duitse dominantie.',
    ],
    [
      'Hoe beïnvloedden de belaste Nazi-achtergronden van West-Duitse elites de politiek van de vroege Bondsrepubliek?',
      [
        'Onvolledige denazificatie stelde elitecontinuïteit mogelijk',
        'West-Duitsland zuiverde alle ambtenaren uit het Nazi-tijdperk volledig',
        'De Bondsrepubliek werd gesticht met perfecte democratische zuiverheid',
        'Personeel uit het Nazi-tijdperk had geen enkele betrokkenheid bij de naoorlogse regering',
      ],
      0,
      'West-Duitse elites behielden vaak hun Nazi-verleden; onvolledige denazificatie liet traditionele machtsstructuren intact.',
    ],
    [
      'Hoe debatteren historici of Koude Oorlog-verdeling aberratie of dieper breuk onthulde?',
      [
        '1945-verdeling als anomalie versus langdurige breuken',
        'Alle historici stemmen in met één interpretatie',
        'Het debat is puur ideologisch zonder wetenschappelijke substantie',
        'Historisch bewijs lost de vraag ondubbelzinnig op',
      ],
      0,
      'Geleerden debatteren of na-1945-verdeling temporaire aberratie of diepere Duitse breuken onthulde.',
    ],
    [
      'Welke institutionele factoren maakten West-Duitslands "Economisch Wonder" (Wirtschaftswunder) mogelijk?',
      [
        'Marshallhulp en de sociale markteconomie',
        'Centrale Sovjet-planning',
        'Uitsluitend focus op landbouw in plaats van industriële ontwikkeling',
        'Volledige afwijzing van buitenlandse investeringen en hulp',
      ],
      0,
      'De Wirtschaftswunder combineerde Marshallhulp, valutahervorming, en Ludwig Erhards sociaal-marktmodel.',
    ],
  ],
  professor: [
    [
      'Hoe herkadert recente geschiedschrijving het falen van het Frankfurtse Parlement in transnationaal vergelijkend licht?',
      [
        'Liberalisme kende vergelijkbare obstakels elders in Europa',
        'Door te bewijzen dat Duitse liberalen incompetenter waren dan die in andere landen',
        'Door te bevestigen dat Duitsland voorbestemd was voor autoritair bewind',
        'Door Treitschkes nationalistische historiografie te onderschrijven',
      ],
      0,
      'Hedendaagse historici gebruiken internationale vergelijkingen om de Duitse Sonderweg-these te weerleggen.',
    ],
    [
      'Hoe plaatst Christopher Clarks herziening van de Julicrisis de rol van Duitsland in de oorsprong van de Eerste Wereldoorlog?',
      [
        'Binnen een multipolair Europees grootmachtensysteem',
        'Door Duitsland van verantwoordelijkheid te absolveren',
        'Door te beweren dat oorlog onvermijdelijk was, ongeacht het gevoerde beleid',
        'Door de Sonderweg-these verder te bevorderen',
      ],
      0,
      'Clark plaatst Duitse beslissingen in de context van concurrerende belangen van grote mogendheden en weerlegt daarmee monocausale verklaringen die alleen Duitse agressie als oorzaak zien.',
    ],
    [
      'Welk historiografisch concept verklaart de Weimar-ineenstorting door elite-deadlock en institutionele fragmentatie?',
      [
        'Vetoïzering: elite-deadlock maakte dictatuur mogelijk',
        'Het proces van succesvolle democratisering',
        'Hoe meervoudige veto-machten individuele vrijheden beschermden',
        'Toenemende machtconcentratie in socialistische partijen',
      ],
      0,
      'Vetoïzeringstheorie beschrijft verdeelde elitedeadlock die Nazi-opkomst mogelijk maakte.',
    ],
    [
      'Hoe herstructureerde de Deutsche Arbeitsfront (Nazi-Arbeidsfront) arbeidsrelaties in vergelijking met de Weimarperiode?',
      [
        'Door onderhandeling af te schaffen ten gunste van corporatistische controle',
        'Door onafhankelijke vakbonden te versterken',
        'Door staatsbemoeienis met arbeidsaangelegenheden te verminderen',
        'Door Sovjet-stijl communistische arbeidsorganisatie aan te nemen',
      ],
      0,
      'De DAF verving onafhankelijke vakbonden door Nazi-gecontroleerd corporatisme: looncontrole en ideologische integratie.',
    ],
    [
      'Wat benadrukt Raul Hilbergs institutionele analyse over het bureaucratische karakter van de Holocaust?',
      [
        'Cumulatieve radicalisering en bureaucratisch momentum',
        'Dat genocide spontaan geweld zonder organisatie was',
        'Dat technologie geen rol in gruweldaden speelde',
        'Dat het uitsluitend voortkwam uit de beslissing van één persoon',
      ],
      0,
      'Hilberg traceerde hoe de Holocaustmachine voortsproot uit bureaucratische interactie en incrementele institutionele radicalisering.',
    ],
    [
      'Hoe vergemakkelijken debatten over "gewone daders" functionalistische interpretaties van Nazi-misdaden?',
      [
        'Ideologische toewijding coëxisteerde met bureaucratie',
        'Door alle daders als toegewijde ideologen te bewijzen',
        'Door institutionele actoren van verantwoordelijkheid te absolveren',
        'Door uitsluitend terug te keren naar intentionalistische Nazi-ideologie-verklaringen',
      ],
      0,
      'Recente geschiedschrijving toont dat daders handelden uit een mengeling van ideologie, carrièrisme en conformisme, niet uit zuiver bureaucratisch handelen.',
    ],
    [
      'Welke historiografische betekenis heeft Eckart Kehrs vlootbouwtheorie voor de politiek van het Duitse Keizerrijk?',
      [
        'Uitbreiding van de vloot versterkte elitecoalities',
        'Puur militair-technische analyse, losgekoppeld van politiek',
        'Dat marinemacht irrelevant is voor politieke ontwikkeling',
        'Een theorie die haar oorsprong heeft in de Nazi-periode',
      ],
      0,
      'Kehr verbond de Duitse slagschipexpansie met elitecoalities: imperialisme leidde de aandacht af van binnenlandse democratische hervormingen.',
    ],
    [
      'Hoe interpreteren geleerden tegenwoordig het Oost-Duitse "staatssocialisme" wat betreft de coëxistentie van legitimiteit en surveillance?',
      [
        'Surveillance met onderhandelde naleving',
        'Als geheel vrijwillig en populair',
        'Als geen veiligheidsapparaat stellend',
        'Als identiek aan West-Duitse bestuursstructuren',
      ],
      0,
      'Recente geschiedschrijving benadrukt dat in de DDR surveillance samenging met beperkte onderhandeling en uiterlijk vertoon.',
    ],
    [
      'Welke historiografische vernieuwing brengt Timothy Snyders "bloodlands"-concept in de vergelijking tussen nazi- en Sovjetgeweld?',
      [
        'Door Oost-Europese burgerslachtoffers centraal te stellen',
        'Door één zijde geheel te exonereren',
        'Door te beweren dat Oost-Europa historisch irrelevant was',
        'Door ideologie ter gunste van zuivere geografie te negeren',
      ],
      0,
      'Snyder zet Oost-Europese slachtoffers centraal in de betwiste zones waar nazi- en Sovjetgeweld botsten.',
    ],
    [
      'Hoe functioneerden monetaire soevereiniteit en de Duitse Mark symbolisch in de West-Duitse naoorlogse identiteit?',
      [
        'De DM symboliseerde economische autonomie',
        'Valuta was irrelevant voor de nationale identiteit',
        'De DM versterkte Duits-Sovjet-relaties',
        'West-Duitsland ontbeerde een onafhankelijk monetair beleid',
      ],
      0,
      'De Duitse Mark symboliseerde West-Duits herstel en autonomie; valutastabiliteit werd centraal voor de identiteitsvorming.',
    ],
    [
      'Welke historiografische debatten karakteriseerden de Historikerstreit van de jaren 1980 (het historicidebat)?',
      [
        'Het debat tussen intentionalisten en functionalisten',
        'Universele overeenstemming onder geleerden over alle interpretaties',
        'Zuiver ideologische geschillen zonder wetenschappelijke nauwkeurigheid',
        'Een geschil onder niet-specialistische commentatoren',
      ],
      0,
      'De Historikerstreit stelde geleerden tegenover elkaar over oorzakelijkheid, continuïteitsnarratieven en de ethische interpretatie van de geschiedenis.',
    ],
    [
      'Hoe interpreteert Konrad Jarauschs "Duits Dilemma"-raamwerk de langdurige spanningen in het Duitse bestuur?',
      [
        'Spanning tussen pluralisme en centralisering',
        'Als bewijs van inherente Duitse inferioriteit',
        'Als uniek Duits zonder Europees parallel',
        'Als permanent opgelost door Duitse eenmaking in 1871',
      ],
      0,
      'Jarausch betoogt dat Duitse pogingen tot eenmaking herhaaldelijk elitecentralisering voorrang gaven boven democratisch pluralisme.',
    ],
    [
      'Hoe bemoeilijkt Dagmar Herzogs werk over seksualiteit monolithische interpretaties van Nazi-controle?',
      [
        'Nazi\'s onderdrukten seksualiteit en stonden die tegelijk toe, afhankelijk van de context',
        'Door te beweren dat de Nazi\'s seksualiteit volledig hadden genegeerd',
        'Door te beweren dat seksuele vrijheid onder het nazisme floreerde',
        'Door Nazi-repressie als volledig ineffectief te bewijzen',
      ],
      0,
      'Herzog onthult tegenstrijdigheden in het Nazi-beleid: homoseksualiteit werd onderdrukt, terwijl heteroseksueel gedrag ten behoeve van raciale voortplanting werd toegestaan.',
    ],
    [
      'Hoe hebben geleerden de West-Duitse studentenbeweging van 1968 heroverwogen binnen generatiegericht geschiedkundig onderzoek?',
      [
        'Als jongeren die hun ouders confronteerden met medeplichtigheid aan het nazisme',
        'Als geheel uit buitenlandse bewegingen geïmporteerd',
        'Als volkomen los van geschiedkundig belangen',
        'Als ondersteuning van bestaande institutionele autoriteiten',
      ],
      0,
      'In 1968 confronteerden West-Duitse studenten het zwijgen van hun ouders over medeplichtigheid aan het nazisme en over de militarisering tijdens de Koude Oorlog.',
    ],
    [
      'Wat stelt David Calleo\'s "Duits Probleem"-raamwerk over de rol van Europese integratie?',
      [
        'Het integreren van Duitse macht binnen Europese instellingen',
        'Dat Duitsland Europa openlijk zou domineren',
        'Dat Europese integratie irrelevant is voor Duitse macht',
        'Dat Duitsland van nature vreedzaam is, ook zonder institutionele beperkingen',
      ],
      0,
      'Calleo betoogt dat Europese instellingen de Duitse macht beperken terwijl ze integratie mogelijk maken, waarmee het "Duits Probleem" wordt opgelost.',
    ],
  ],
};
